import {
  getTokenFromLocalStorage,
  hasPermission,
} from "../../../helpers/helpers"
import React, {useEffect, useState} from "react"
import { Card, Button, CardBody, Row, Col } from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {CSVExport, Search} from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import { getFakeData } from "./depositsData"
import * as moment from "moment"

function DepositsTable(props) {
  const { data } = props
  const Columns = [
    {
      dataField: "msisdn",
      text: "Mobile",
      sort: true,
    },
    {
      dataField: "channel",
      text: "Channel",
      sort: true,
    },
    {
      dataField: "payment_type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      formatter: (cell, row) => (
        <> {Number(Number(row?.amount).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "success_at",
      text: "Date",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.date)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "reference_id",
      text: "Reference",
      sort: true,
    },
    {
      dataField: "operatorreference",
      text: "Operator Reference",
      sort: true,
    },
    {
      dataField: "customerreference",
      text: "Customer Reference",
      sort: true,
    },
    {
      dataField: "txn_status",
      text: "Status",
      sort: true,
      // formatter: (cell, row) => <>{
      //   (( (row?.txn_status) && (row?.txn_status != "200")) ? "False" : "True")
      //   }
      // </>
    },
  ]
  const ManualColumn = [
    {
      dataField: "transaction_to.phone_number",
      text: "Transaction To",
      sort: true,
      formatter: (cell, row) => <> {row?.transaction_to?.phone_number}</>,
    },
    {
      dataField: "transaction_by.name",
      text: "Transaction By",
      sort: true,
      formatter: (cell, row) => <> {row?.transaction_by?.name}</>,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      formatter: (cell, row) => <>{row?.amount}</>,
    },
    {
      dataField: "created_at",
      text: "Date",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "reason",
      text: "Reason",
      sort: true,
    },
  ]
  const ManualBonusColumn = [
    {
      dataField: "bonus_to.phone_number",
      text: "Bonus To",
      sort: true,
      formatter: (cell, row) => <> {row?.bonus_to?.phone_number}</>,
    },
    {
      dataField: "bonus_by.name",
      text: "Bonus By",
      sort: true,
      formatter: (cell, row) => <> {row?.bonus_by?.name}</>,
    },
    {
      dataField: "bonus_status",
      text: "Type",
      sort: true,
    },
    {
      dataField: "bonus_amount",
      text: "Amount",
      sort: true,
      formatter: (cell, row) => <>{row?.bonus_amount}</>,
    },
    {
      dataField: "created_at",
      text: "Date",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "reason",
      text: "Reason",
      sort: true,
    },
  ]

  useEffect(() => {
    props.call()
  }, [props.depositType])

  const defaultSorted = [
    {
      dataField: "msisdn",
      order: "desc",
    },
  ]

  const optionsDeposit = [
    { label: "TolaPayment", value: "TolaPayment" },
    { label: "ManualPayment", value: "ManualPayment" },
    { label: "ManualBonus", value: "ManualBonus" },
  ]
  const { SearchBar } = Search
  //pagination customization
  const { ExportCSVButton } = CSVExport;

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data.length,
    custom: true,
  }
  return (
    <Card>
      <CardBody>
        <div className="mb-4 h4 card-title">{"Deposits"}</div>
        <PaginationProvider
          pagination={paginationFactory(pageOptions)}
          keyField="id"
          columns={
            props.depositType=="ManualPayment" ?
            ManualColumn : (props.depositType=="ManualBonus" ? ManualBonusColumn : Columns)
          }
          data={data}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="id"
              data={data}
              columns={
                props.depositType=="ManualPayment" ?
                    ManualColumn : (props.depositType=="ManualBonus" ? ManualBonusColumn : Columns)
              }
              bootstrap4
              search
              exportCSV={ { onlyExportFiltered: true, exportAll: false, fileName: `Deposit-record-${moment(new Date()).format("DD/MM/YYYY")}.csv`}}
            >
              {toolkitProps => (
                <React.Fragment>
                  <Row className="mb-2">
                    <Col sm="6">
                      <Row>
                        <Col sm="4">
                          <div className="search-box me-2 mb-2 d-inline-block">
                            <div className="position-relative">
                              <SearchBar {...toolkitProps.searchProps} />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                        <Col sm="4">
                          <Select
                              options={optionsDeposit}
                              maxMenuHeight={150}
                              classNamePrefix="select2-selection"
                              onChange={item => {
                                props.setDepositType(item.label)
                              }}
                              value={{label: props.depositType, value: props.depositType}}
                          />
                          {/*<Select*/}
                          {/*  options={[*/}
                          {/*    { label: "Pending", value: "Pending" },*/}
                          {/*    { label: "Success", value: "Success" },*/}

                          {/*    { label: "Failed", value: "Failed" },*/}
                          {/*    { label: "Rejected", value: "Rejected" },*/}
                          {/*    { label: "All", value: "All" },*/}
                          {/*  ]}*/}
                          {/*  maxMenuHeight={150}*/}
                          {/*  classNamePrefix="select2-selection"*/}
                          {/*  onChange={item => {*/}
                          {/*    setItem(item.label)*/}
                          {/*  }}*/}
                          {/*  value={{ label: item, value: item }}*/}
                          {/*/>*/}
                        </Col>
                        <Col sm="4">
                          <div>
                            <ExportCSVButton { ...toolkitProps.csvProps } className="download-table-xls-button w-md btn btn-primary">Download</ExportCSVButton>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={6}>
                      {/*{hasPermission("create-deposits") && (*/}
                      {/*  <Col sm="12">*/}
                      {/*    <div className="text-sm-end">*/}
                      {/*      <Button*/}
                      {/*        type="button"*/}
                      {/*        color="success"*/}
                      {/*        className="btn-rounded  mb-2 me-2"*/}
                      {/*      >*/}
                      {/*        <i className="mdi mdi-plus me-1" />*/}
                      {/*        Add New*/}
                      {/*      </Button>*/}
                      {/*    </div>*/}
                      {/*  </Col>*/}
                      {/*)}*/}
                    </Col>
                  </Row>
                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField="id"
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          //   selectRow={selectRow}
                          classes={
                            "table align-middle table-nowrap table-check"
                          }
                          headerWrapperClasses={"table-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                          rowClasses={"mytable-hover-row"}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="pagination pagination-rounded justify-content-end">
                    <PaginationListStandalone {...paginationProps} />
                  </div>
                </React.Fragment>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </CardBody>
    </Card>
  )
}

export default DepositsTable
